<template>
	<div>
		<iframe
			v-once
			scrolling="no"
			:src="zoomUrl"
			class="element-position"
			:class="className"
			:style="style"
			v-if="isZoom && isLive"
		/>
		<!-- @TODO: -->
		<img
			scrolling="no"
			class="element-position"
			:class="className"
			:style="style"
			:src="zoomImg"
			v-if="!isLive"
		/>
		<!-- Video Element -->
	</div>
</template>

<script>
export default {
	name: 'ElementZoom',
	props: {
		item: {
			type: Object,
		},
		status: {
			type: String,
		},
	},
	methods: {
	},
	computed: {
		zoomImg() {
			const zoomImgUrl = `${process.env.VUE_APP_URL}/img/zoommeeting.png`;
			return zoomImgUrl;
		},
		isLive() {
			const live = this.status && this.status === 'live';
			return live;
		},
		content() {
			return this.item.content && this.item.content !== ''
				? JSON.parse(this.item.content) : {};
		},
		className() {
			return this.content.position ? this.content.position : '';
		},
		style() {
			const style = {};
			style.position = 'absolute';
			style.border = '0';
			style.zIndex = this.item.layer_index;
			const content = this.content;
			if (content.opacity) style.opacity = content.opacity;
			if (content.width) style.width = `${content.width}px`;
			if (content.height) style.height = `${content.height}px`;
			if (content.y) style.top = `${content.y}px`;
			if (content.x) style.left = `${content.x}px`;
			return style;
		},
		isZoom() {
			return this.item.type === 'zoom_meeting';
		},
		zoomUrl() {
			const zoomService = process.env.VUE_ZOOM_URL || 'https://zoom.supersource.live/';
			const q = '?';
			const meetingDisplayName = `${this.content.meetingDisplayName}`;
			const meetingNumber = `${this.content.meetingNumber}`;
			const meetingPassword = `${this.content.meetingPassword}`;
			const meetingRole = `${this.content.meetingRole}`;

			if (meetingDisplayName && meetingNumber && meetingPassword && meetingRole) {
				return `${zoomService}${q}&username=${meetingDisplayName}&meetingnum=${meetingNumber}&meetingpas=${meetingPassword}&role=${meetingRole}`;
			}

			return '';

			// ?username=${this.playlistItem.content.zoomUserName}&meetingnum=${this.playlistItem.content.zoomMeetingNumber}&meetingpas=${this.playlistItem.content.zoomMeetingPassword}&role=${this.playlistItem.content.zoomRole}`
		},
	},
};
</script>
